<template>
  <a-form layout="vertical" class="form">
    <a-form-item label="Desde">
      <a-date-picker
        class="picker"
        v-model:value="from"
        :format="humanDateFormat"
        valueFormat="YYYY-MM-DD"
        @change="handleChange($event, 0)"
      />
    </a-form-item>

    <a-form-item label="Hasta">
      <a-date-picker
        class="picker"
        v-model:value="to"
        :format="humanDateFormat"
        valueFormat="YYYY-MM-DD"
        @change="handleChange($event, 1)"
      />
    </a-form-item>
  </a-form>
</template>

<script>
import { dateFormat } from "@/app/shared/utils/constants";
import { humanDateFormat } from "@/app/shared/utils/constants";
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      values: [],
      dateFormat,
      from: this.value[0],
      to: this.value[1],
      humanDateFormat,
    };
  },
  watch: {
    value(value) {
      this.from = value[0];
      this.to = value[1];
    },
  },
  methods: {
    handleChange(value, index) {
      this.values[index] = value;
      this.$emit("update:value", [this.from, this.to]);
    },
  },
});
</script>

<style lang="sass" scoped>
.form
  display: flex
  gap: 12px

  .ant-form-item
    flex: 1 1 50%

  .picker
    width: 100%

.text
  padding: 12px 24px
  margin: 0

  &--bold
    color: $gray-9
    font-weight: 600

.ant-form-item
  margin-bottom: 4px
</style>
